import React from 'react';
import classNames from 'classnames';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import styles from './MobileMenuTabs.scss';
import { Category, MOBILE_MENU_TABS } from '../../constants';
interface MobileMenuTabsProps {
  activeTab?: string;
  isTabbable?: boolean;
  onActiveTabChange: (tab: Category) => void;
}

export const MobileMenuTabs = ({
  activeTab = Category.SHOP,
  isTabbable = true,
  onActiveTabChange,
}: MobileMenuTabsProps) => {
  const handleTabChange = (tab: Category) => {
    onActiveTabChange(tab);
    if (tab !== Category.SHOP) {
      sendEvent(`navigation.tab.${tab.toLowerCase()}.click`);
    }
  };

  const handleTabClick = (tab: Category) => {
    handleTabChange(tab);
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>,
    tab: Category
  ) => {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    handleTabChange(tab);
  };

  return (
    <div className={styles.mobileMenuTabs}>
      <ul className={styles.mobileMenuTabsList}>
        {MOBILE_MENU_TABS.map(menuItem => (
          <li
            key={menuItem}
            className={classNames(styles.mobileMenuTabsListItem, {
              [styles.mobileMenuTabsListItemIsActive]: menuItem === activeTab,
            })}
          >
            <button
              className={styles.mobileMenuTabsButton}
              onClick={() => handleTabClick(menuItem)}
              onKeyDown={event => handleKeyDown(event, menuItem)}
              tabIndex={isTabbable ? 0 : -1}
              data-current-tab={menuItem === activeTab ? 'true' : 'false'}
              data-mobile-tab={menuItem}
              aria-haspopup="true"
              aria-expanded={menuItem === activeTab ? 'true' : 'false'}
            >
              {menuItem}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
